import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { ResponseModel } from '../../shared/models/response-model.model';
import { tap } from 'rxjs';
import { MarketingTemplateModel } from './whatsapp-template.model';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplateService {

  constructor(public service: DataService,private http: HttpClient) { }

  getSalesByModules(){
    let url = `api/App/SalesByModule/salesByModules`;
    return this.service.get(url).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  insertUpdateMarketingTemplate(data:MarketingTemplateModel){
    let url = "api/App/MarketingTemplate/insertUpdateMarketingTemplate";
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  deleteMarketingTemplate(id:any){
    let url = `api/App/MarketingTemplate/deleteMarketingTemplate?Id=${id}`;
    return this.service.delete(url,true).pipe<ResponseModel>(tap((response: any) => {
      return response;
      })
    );
  }

  getAllMarketingTemplate(data:any){
    let url = "api/App/MarketingTemplate/getAllMarketingTemplate";
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
      return response;
        })
      );
  }

  downloadDocuments(data?:any) {
    let url = `api/App/MarketingTemplate/downloadTemplateImages`;
    return this.service.post(url,data,true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }

  insertMsgiFlyUserDetails(data:any){
    let url = "api/App/User/insertMsgiFlyUserDetails";
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  getAllMsgFlyUser(data: any) {
    const url = 'api/App/User/getAllMsgFlyUser';
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => response)
    );
  }
}
